


























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'

settings = 
  name: 'UIList'
  vue:
    components: { LoadingIndicator }
    computed:
      hasEmpty: -> @$slots['empty']?
      hasBulkActions: -> @$slots['bulk-actions']?
      hasPrimaryFilters: -> @$slots['primary-filters']?
      hasHeading: -> @$slots['heading']?
      hasHeader: -> @hasBulkActions || @hasPrimaryFilters || @hasHeading

export default VueOptions.vue settings
